module.exports = __webpack_public_path__ + "img/71ne.79ee2636.svg";